const YOGI_DOMAIN = 'meetyogi.com'

const domainOf = (email: string): string =>
  email.split('@')[1]?.trim().toLowerCase() ?? ''

/**
 * Client mirror of the backend's cross-domain sharing rule (the backend is
 * authoritative and rejects disallowed targets with 403). Allowed when either
 * side is Yogi staff, the domains match exactly, or the target's domain is on
 * the hub's allowlist (stored lowercased).
 */
export function canShareWith(
  inviterEmail: string,
  targetEmail: string,
  allowedDomains: readonly string[],
): boolean {
  const inviterDomain = domainOf(inviterEmail)
  const targetDomain = domainOf(targetEmail)
  if (!targetDomain) return false
  return (
    inviterDomain === YOGI_DOMAIN ||
    targetDomain === YOGI_DOMAIN ||
    targetDomain === inviterDomain ||
    allowedDomains.includes(targetDomain)
  )
}
